export default [
	{label : 'Plumbing', value: 'Plumbing'},
	{label : 'Electrical', value: 'Electrical'},
	{label : 'Building', value: 'Building'},
	{label : 'Other', value: 'Other'},
	{label : 'HVAC', value: 'HVAC'},
	{label : 'Data & Security', value: 'Data & Security'},
	{label : 'Landscaping', value: 'Landscaping'},
	{label : 'Roofing', value: 'Roofing'},
	{label : 'Cleaning', value: 'Cleaning'},
	{label : 'Repairs/Maintenance', value: 'Repairs/Maintenance'},
	{label : 'Other Trade', value: 'Other Trade'},
	{label : 'Painting', value: 'Painting'},
	{label : 'IT Services', value: 'IT Services'},
	{label : 'Flooring', value: 'Flooring'}
];


// WEBPACK FOOTER //
// ./app/constants/industryList.js